import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

const getters = {
  token: state => state.user.token,
  username: state => state.user.username,
  roleCode: state => state.user.roleCode
}

export default new Vuex.Store({
  modules: {
    user
  },
  getters
})
